import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { Layout } from '@/components/layout';
import { ProtectedRoute } from '@/components/auth';
import { Dashboard } from '@/components/dashboard';
import { Login } from '@/components/auth';
import { RegisterPage } from '@/components/auth/register/pages/RegisterPage';
import { AppWrapper } from '@/components/common/AppWrapper';
import { LoadingScreen } from '@/components/common/LoadingScreen';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { ApiLoadingScreen } from '@/components/common/ApiLoadingScreen';
import { useSettingsStore } from './store';
import PrivacyPolicy from './components/privacy';

export default function App() {
  const [isInitializing, setIsInitializing] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { user, initializeAuth } = useAuthStore();

  useEffect(() => {
    async function init() {
      try {
        useSettingsStore.getState().fetchSettings();
        setIsInitializing(true);
        setError(null);
        await initializeAuth();
      } catch (err) {
        console.error('Auth initialization error:', err);
        setError('حدث خطأ أثناء تحميل البيانات');
      } finally {
        setIsInitializing(false);
      }
    }

    init();
  }, [initializeAuth]);

  if (isInitializing) {
    return <LoadingScreen />;
  }

  if (error) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center p-4">
        <div className="bg-white rounded-lg shadow-sm p-6 max-w-md w-full text-center">
          <p className="text-red-500">{error}</p>
          <button 
            onClick={() => window.location.reload()}
            className="mt-4 px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark"
          >
            إعادة المحاولة
          </button>
        </div>
      </div>
    );
  }

  return (
    <ErrorBoundary>
      <ApiLoadingScreen>
        <AppWrapper>
          <Router>
            <Routes>
              <Route path="/register" element={<RegisterPage />} />
              
              <Route
                path="/dashboard/*"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Dashboard />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/login"
                element={
                  user ? <Navigate to="/dashboard/tree" replace /> : <Login />
                }
              />
              <Route
                path="/"
                element={
                  user ? (
                    <Navigate to="/dashboard/tree" replace />
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Router>
        </AppWrapper>
      </ApiLoadingScreen>
    </ErrorBoundary>
  );
}